import { controlaHabilitacaoDosCampos } from '../../../ibsCbs/controlaHabilitacaoDosCampos';
import { seletoresParametrizacoes } from '../../../ibsCbs/constants';

document.addEventListener('DOMContentLoaded', () => {
  const SELETORES_CONFIGURACAO = {
    NCM: {
      situacaoTributariaId: seletoresParametrizacoes.NCM.cstSelect,
      classificacaoTributariaId: seletoresParametrizacoes.NCM.cClassTribSelect
    },
    OPERACOES: {
      situacaoTributariaId: seletoresParametrizacoes.OPERACOES.cstSelect,
      classificacaoTributariaId: seletoresParametrizacoes.OPERACOES.cClassTribSelect
    },
    CLIENTES: {
      situacaoTributariaId: seletoresParametrizacoes.CLIENTES.cstSelect,
      classificacaoTributariaId: seletoresParametrizacoes.CLIENTES.cClassTribSelect
    },
    NOTAS_FISCAIS: {
      situacaoTributariaId: seletoresParametrizacoes.NOTAS_FISCAIS.cstSelect,
      classificacaoTributariaId: seletoresParametrizacoes.NOTAS_FISCAIS.cClassTribSelect
    }
  };

  Object.values(SELETORES_CONFIGURACAO).forEach(configuracao => {
    controlaHabilitacaoDosCampos(configuracao);
  });
});